import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PlantActions";
import * as api from "../../api/PlantApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";


function* getPlantList() {
    try {
        const { data } = yield api.getPlantList();
        yield put(actions.setPlantList(data || undefined));
    } catch (error) {
        yield put(actions.setPlantList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addPlant(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addPlant(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updatePlant(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updatePlant(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePlant(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deletePlant(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_PLANT_LIST, getPlantList);
    yield takeEvery(actions.Types.ADD_PLANT, addPlant);
    yield takeEvery(actions.Types.UPDATE_PLANT, updatePlant);
    yield takeEvery(actions.Types.DELETE_PLANT, deletePlant);
}

const plantSaga = [fork(watchAll)];

export default plantSaga;
